import { Close } from "@mui/icons-material";
import { Button } from "@mui/material";
import useSearchParamsWithUpdate from "helpers/hooks/useSearchParamsWithUpdate";

interface ClearFiltersButtonProps {
  qpIgnore: string[];
}

const ClearFiltersButton = ({ qpIgnore }: ClearFiltersButtonProps) => {
  const { searchParams, setSearchParams } = useSearchParamsWithUpdate();
  const anyFilters = Array.from(searchParams.entries()).filter((p) => !qpIgnore.includes(p[0])).length > 0;

  const clearFilters = () => {
    setSearchParams([]);
  };

  return anyFilters ? (
    <Button color="default" onClick={clearFilters} size="small" variant="contained" endIcon={<Close />}>
      Clear
    </Button>
  ) : (
    <></>
  );
};

export default ClearFiltersButton;
